<template>
    <div class="max-w-lg mx-auto md:mt-5">
        <div :key="answerIndex" v-for="(answer, answerIndex) of question.answers">
            <template v-if="typeof question.custom_message !== 'undefined' && question.custom_message.length > 0">
                <div class="text-white text-center font-size-16 pb-2">
                    {{ question.custom_message }}
                </div>
            </template>

            <form @submit.prevent="answerSubmit(answerIndex)">
                <Input
                    class="input input-block input-text-center input-remove-margin font-size-16 md:font-size-22 theme-question-text-color"
                    v-model="typingAnswer"
                    type="text"
                    :placeholder="$t('question_typing_the_correct_answer')"
                />
                <div class="flex items-center flex-col justify-center w-full h-full mt-6 md:mt-5">
                    <button class="theme-button btn text-2xl font-opensans font-size-22 btn-large block mb-1 uppercase">
                        {{ $t('question_typing_submit') }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import stringSimilar from 'string-similarity'
import Sound from '@/lib/sound.js'
import pop from '@/assets/sounds/pop.mp3'
import definite from '@/assets/sounds/definite.mp3'
import Input from '@/components/Input.vue'

export default {
    props: {
        question: {
            type: Object,
            default: null
        },
        isPlayAlone: {
            type: Boolean,
            default: false
        }
    },

    components: {
        Input
    },

    watch: {
        question: question => {
            this.modifyQuestion(question.answers[0])
        }
    },

    mounted() {
        this.modifyQuestion(this.question.answers[0])

        this.$nextTick(() => {
            setTimeout(() => {
                window.dispatchEvent(new CustomEvent('componentAlready'))
            }, 200)
        })
    },

    data() {
        return {
            typingAnswer: '',
            sound: new Sound()
        }
    },

    created() {
        this.sound.registerSound({ id: 'pop', src: pop })
        this.sound.registerSound({ id: 'definite', src: definite })
    },

    methods: {
        modifyQuestion(answer) {
            this.question.answers[0] = {
                title: answer.title,
                image: answer.image,
                is_correct: answer.is_correct,
                score: answer.score != undefined ? answer.score : 0,
                data: {
                    sorting_choices:
                        typeof answer.data != 'undefined' && typeof answer.data.sorting_choices != 'undefined'
                            ? answer.data.sorting_choices
                            : [],
                    accepted_percentage:
                        typeof answer.data != 'undefined' && typeof answer.data.accepted_percentage != 'undefined'
                            ? answer.data.accepted_percentage
                            : 0,
                    completely_correct:
                        typeof answer.data != 'undefined' && typeof answer.data.completely_correct != 'undefined'
                            ? answer.data.completely_correct
                            : true
                }
            }
        },

        answerSubmit(answerIndex) {
            // this.sound.play('definite') // try to use sound 'pop' instead of 'definite'
            if (this.isPlayAlone) {
                this.sound.play('pop')
            }
            const acceptedPercent = this.question.answers[answerIndex].data.completely_correct
                ? 100
                : parseFloat(this.question.answers[answerIndex].data.accepted_percentage)
            if (isNaN(parseInt(this.question.answers[answerIndex].title))) {
                // Check if answer is text
                var compare = stringSimilar
                    .compareTwoStrings(
                        this.question.answers[answerIndex].title.toLowerCase(),
                        this.typingAnswer.toLowerCase()
                    )
                    .toFixed(4)
                var similarPercent = parseFloat(compare) * 100

                this.$emit('value', {
                    value: similarPercent >= acceptedPercent,
                    typingAnswer: this.typingAnswer
                })
            } else {
                // Check if answer is number
                var inputNumber = isNaN(parseFloat(this.typingAnswer)) ? NaN : parseFloat(this.typingAnswer),
                    answerNumber = parseFloat(this.question.answers[answerIndex].title),
                    value = false

                if (!isNaN(inputNumber)) {
                    var differentPercent = (Math.abs(answerNumber - inputNumber) / answerNumber) * 100
                    value = 100 - differentPercent >= acceptedPercent
                }

                this.$emit('value', {
                    value: value,
                    typingAnswer: this.typingAnswer
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.input {
    color: var(--button-text-color);
    background-color: var(--ui-color-alpha-50);
    border-color: var(--ui-color) !important;

    &::placeholder {
        text-transform: initial;
    }

    &::-webkit-input-placeholder {
        text-transform: initial;
    }

    &:-moz-placeholder {
        text-transform: initial;
    }

    &::-moz-placeholder {
        text-transform: initial;
    }

    &:-ms-input-placeholder {
        text-transform: initial;
    }
}
</style>
